import { FC } from 'react';

import { useFormat } from '../../../hooks/index';
import { AppFormattedMessage } from '../../app-formatted-message/index';
import { Badge } from '../badge';
import { useIntervalFromToday } from '../format-date.util';

type NotificationProps = {
  adminName: string;
  createdAt: Date;
  message: string;
  requestDate: Date;
  type: string;
};

export const ResolvedNotification: FC<NotificationProps> = ({
  createdAt,
  message,
  type,
  requestDate,
  adminName,
}) => {
  const { format } = useFormat();
  const date = useIntervalFromToday(createdAt);

  return (
    <div className="flex flex-col gap-4 rounded-lg border border-gray-200 bg-white px-4 py-3">
      <div className="flex w-full justify-between text-label-md font-medium text-gray-500">
        <span>{type}</span>
        <span>{date}</span>
      </div>
      <div className="flex gap-3">
        <div className="size-10 shrink-0 rounded-full bg-gray-200" />
        <div className="flex flex-col gap-1">
          <span className="text-sm font-[450] text-black">{message}</span>
          <div className="flex gap-1">
            <div className="h-10 w-1 border-b border-l border-gray-200" />
            <div className="mt-[27px] flex flex-col gap-2">
              <Badge
                className="!text-label-md font-medium text-forest-500"
                title={<AppFormattedMessage id="MARK_AS_RESOLVED" />}
              />
              <span className="text-sm font-[450] text-black">
                {adminName} marked the request as resolved
              </span>
              <span className="text-label-md font-medium text-gray-500">
                {format(requestDate, 'dd/MM/yyyy')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
